<div class="dropdown dropdown--remove-info-invalid-icon">
  <ng-content select="[dropdownPanel]"></ng-content>
  @if (isOpen && !disabled) {
    <div class="dropdown-content" [class.dropdown-content--full-width]="isDropdownListFullWidth"
         [class.open-down-up]="openDropdownUpwards"
         [class.is-dark-dropdown]="isDarkDropdown"
         [class.left]="leftAlign">
      <ng-content select="[dropdownContent]"></ng-content>
    </div>
  }
</div>
